<template>
  <div :class="['app-container', $style.wrap]">
    <div :class="$style.title">
      <p>
        极致游戏账号注销
      </p>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "CancellationLayout",
  data() {
    return {};
  }
};
</script>

<style module lang="less">
.wrap {
  .size(100%);
}
.title {
  .flex-row;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: #48d5af;
  & > img {
    .size(0.38rem);
    object-fit: fill;
    margin-right: 0.2rem;
  }
  & > p {
    font-size: 0.3rem;
    font-weight: bold;
    text-align: center;
    color: #fff;
    padding: 0.3rem 0;
  }
}
</style>
